import { createStore, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import reducer from "./reducers";
import { persistStore, persistReducer, createMigrate } from "redux-persist";
import localForge from "localforage/dist/localforage.js";
import { migrations } from "./reducers/cart";
import { asyncDispatchMiddleware } from "./asyncDispatchMiddleware";
import {
  checkoutV2PersistTransform,
  migrateCheckoutV2State,
} from "../checkout-v2/state/persistence";
import { checkoutV2LifecycleMiddleware } from "../checkout-v2/state/middleware";
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistConfig = {
  key: "cart",
  version: 19,
  storage: localForge,

  migrate: createMigrate(
    { ...migrations, 19: migrateCheckoutV2State },
    { debug: false },
  ),
  transforms: [checkoutV2PersistTransform],
  whitelist: [
    "cart",
    "customers",
    "PastOrders",
    "branch",
    "promise",
    "currency",
    "abandonedCart",
    "checkoutV2",
    // "productFilter",
  ],
};
const persistedReducer = persistReducer(persistConfig, reducer);
const store = createStore(
  persistedReducer,
  composeEnhancers(
    applyMiddleware(
      thunk,
      asyncDispatchMiddleware,
      checkoutV2LifecycleMiddleware,
    ),
  )
);
const persistor = persistStore(store);

export { persistor, store };
